<template>
  <section class="ProductCaracteristics" :class="{'zeborne': isZeborne}">
    <div class="container-small">
      <div class="Separator-title" @click="isMobile ? (hiddenEllement = !hiddenEllement) : false">
        Caractéristiques <span>techniques</span>
        <svg
          v-svg
          symbol="Arrow_Right"
          size="0 0 18 18"
          role="presentation"
          class="icon--inline Separator-chevron mobileOnly"
          :class="{ Reveal: hiddenEllement === false }"
        ></svg>
      </div>

      <transition name="slide-fade">
        <div class="ProductCaracteristics-inner" v-if="!hiddenEllement">
          <ul
            class="ProductCaracteristics-list"
            data-scroll="caracteristics"
            :class="{ close: !show }"
          >
            <li
              v-for="(item, index) in productCaracteristics"
              :key="index"
              class="ProductCaracteristics-listRow"
            >
              <div class="ProductCaracteristics-listIndex">{{ item.label }}</div>
              <div v-if="parseFloat(item.value) > 0" class="ProductCaracteristics-listItem">
                {{ parseFloat(item.value) }}
              </div>
              <div v-else class="ProductCaracteristics-listItem">
                {{ item.value }}
              </div>
            </li>

            <transition name="slide-fade">
              <div class="ProductCaracteristics-expendButton" v-if="!show" @click="show = !show">
                Voir toutes les caractéristiques
              </div>
            </transition>
          </ul>

          <div class="Product-menuTarget" data-links="description" id="description"></div>
          <div class="ProductHydates-productDescription">
            <ProductDescription data-scroll="description"></ProductDescription>
          </div>
        </div>
      </transition>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import ProductDescription from "@/components/Product/ProductDescription/ProductDescription.vue";
import "@/components/Product/ProductCaracteristics/ProductCaracteristics.scss";

export default {
  name: "ProductCaracteristics",

  components: {
    ProductDescription,
  },

  data () {
    return {
      show: false,
      hiddenEllement: false,
      isMobile: false,
    };
  },

  mounted () {
    if (this.productCaracteristics && window.innerWidth < 1100) {
      this.isMobile = true;
      this.hiddenEllement = true;
    }
  },

  computed: {
    ...mapGetters({ productCaracteristics: "getProductCaracteristics" }),
    ...mapGetters({ isZeborne: "isZeborne"}),
  },
};
</script>
